// removed by extract-text-webpack-plugin
module.exports = {"webvr":"styles-module__webvr___2GCMO","webvrSupported":"styles-module__webvrSupported___1_BbM styles-module__webvr___2GCMO","webvrNotSupported":"styles-module__webvrNotSupported___1aCGw styles-module__webvr___2GCMO"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/components/WebVR/styles.module.css
// module id = 134
// module chunks = 0